<template>
  <div>
    <LoadingWidget v-if="loading" />

    <transition name="fade">
      <v-container v-if="!loading" class="py-10 py-md-13 py-lg-16 item">
        <TitleWidget class="text-center">{{ item.title }}</TitleWidget>

        <v-row class="mt-10 mt-md-16" v-if="item.title" align="start">
          <v-col sm="6" cols="12">
            <div
              v-if="item.text"
              class="grey--text text--darken-1 ck-content item-text"
              v-html="item.text"
            ></div>
          </v-col>
          <v-col sm="6" cols="12">
            <img
              v-if="image"
              class="d-block item-img"
              :src="files + image + '?resize=1&w=960'"
              :alt="item.title"
              width="100%"
            />
          </v-col>
        </v-row>

        <div v-if="images.length" class="mt-12">
          <v-row justify="center">
            <v-col cols="12">
              <TitleWidget class="text-center" small>
                Galeria de Fotos
              </TitleWidget>

              <CoolLightBox
                :items="images"
                :index="index"
                @close="index = null"
              />

              <div class="mt-8 images-grid-list">
                <img
                  class="d-block cursor-pointer"
                  @click="index = keyImages"
                  :src="img + '?resize=1&w=300'"
                  width="100%"
                  v-for="(img, keyImages) in images"
                  :key="keyImages"
                />
              </div>
            </v-col>
          </v-row>
        </div>

        <v-alert v-else type="info" width="100%">
          Nenhum conteúdo adicionado até o momento.
        </v-alert>
      </v-container>
    </transition>
  </div>
</template>

<script>
import LoadingWidget from "../components/widgets/LoadingWidget.vue";
import TitleWidget from "../components/widgets/TitleWidget.vue";
import CoolLightBox from "vue-cool-lightbox";
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";

const _config = {
  mod: "about",
};

export default {
  data: () => ({
    loading: true,
    index: null,
  }),
  created() {
    this.$rest(_config.mod)
      .get({
        save: (state, data) => (state.item = data),
      })
      .then(() => (this.loading = false));
  },
  computed: {
    item() {
      return this.$rest(_config.mod).item;
    },
    image() {
      return this.item.img &&
        this.item.img.featured &&
        this.item.img.featured.path
        ? this.item.img.featured.path
        : "";
    },
    images() {
      const images = [];
      if (this.item.img && this.item.img.list && this.item.img.list.length)
        this.item.img.list.map(({ path }) => {
          if (path != this.image) images.push(this.files + path);
        });

      return images;
    },
  },
  components: {
    LoadingWidget,
    TitleWidget,
    CoolLightBox,
  },
};
</script>

<style lang="scss" scoped>
.images-grid-list {
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(4, 1fr);

  @media screen and (max-width: 960px) {
    gap: 5px;
    grid-template-columns: repeat(3, 1fr);
  }

  @media screen and (max-width: 600px) {
    grid-template-columns: repeat(2, 1fr);
  }

  img {
    aspect-ratio: 16 / 12;
    -o-object-fit: cover;
    object-fit: cover;
  }
}
</style>
